// Method that returns the plural form (add s) of single if it occurs more than onces
export const pluralize = (single: string, occurrences: number = 0): string => {
  if (occurrences > 1) return `${single}s`;
  else return single;
};
